import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientService } from '../../client.service';
import { InterceptorSkipHeader } from '../operational-data/operational-data.constants';

import { OAuthTokenInfo } from './authentication.model';

@Injectable()
export class AuthenticationApi {
  private readonly version = 'v1';

  constructor(private clientService: ClientService) {}

  /**
   * get CSRF token
   * @param appId
   * @param version
   */
  getCSRFToken(appId: string, version: string = this.version): Observable<{ token: string }> {
    const endpoint = `auth/${version}/saml/csrf`;

    return this.clientService.post(endpoint, { appId });
  }

  validateOAuthToken(token: string): Observable<OAuthTokenInfo> {
    return this.clientService.get(
      // cannot use http://iam.viessmann-climatesolutions.com/idp/v1/tokeninfo  directly because of cors
      // estrella proxy https://api.viessmann-platform.io/auth/v1/validate
      'auth/v1/validate',
      {},
      new HttpHeaders({
        Authorization: 'Bearer ' + token?.trim(),
        [InterceptorSkipHeader]: '',
      })
    );
  }
}
